import React from 'react';
import Translate from 'react-translate-component';
import { Button } from 'antd';
import { canPrint } from 'utils/print';

import {
    TEXT,
    IMAGE,
    FRAME,
} from 'constants/documentTypes';

import DocumentDownload from 'components/cards/document/DocumentDownload';

const showDownload = {
    TEXT,
    IMAGE,
    FRAME
};

export default function DocumentPreviewFooter(props) {
    const { close, edit, document, documentPreviewType } = props;
    const hasLink = documentPreviewType && showDownload[documentPreviewType];
    const isSuccess = props.isSuccess;
    const showPrint = isSuccess && canPrint(documentPreviewType);

    return (
        <div>
            { showPrint && (
                <Button onClick={() => props.print.current.handlePrint()}>
                    <Translate content="events.print" />
                </Button>
            )}
            { hasLink && <DocumentDownload document={document} /> }
            { edit && (
                <Button onClick={edit}>
                    <Translate content="events.resultEdit" />
                </Button>
            )}
            { close && (
                <Button onClick={() => close()}>
                    <Translate content="modal_settings.cancel" />
                </Button>
            )}
        </div>
    );
}
